<template>
  <header :class="{ fixed: fixedNav == 1 }">
      <router-link to="/" title="Przejdź do strony głównej"><h1>Wirtualne Biuro</h1></router-link>
      <a class="tel" href="tel:+48713369521">+48 71 336 95 21</a>
      <div class="flexi">
        <nav class="main">
          <ul>
            <li><router-link :class="{ active: route == 'Packets' }" to="/pakiety" title="Pakiety">Pakiety</router-link></li>
            <li><router-link :class="{ active: route == 'Faq' }" to="/faq" title="Faq">FAQ</router-link></li>
            <li><router-link :class="{ active: route == 'Gallery' }" to="/galeria" title="Galeria">Galeria</router-link></li>
            <li><a :href="panel" title="Panel klienta">Panel klienta</a></li>
            <!-- <li><router-link to="/blog" title="Blog">Blog</router-link></li> -->
            <li><a href="https://www.afk-cob.pl/" title="Przedź do strony głównej AFK COB">AFK COB</a></li>
            <li><router-link :class="{ active: route == 'Contact' }" to="/kontakt" title="Kontakt">Kontakt</router-link></li>
          </ul>
        </nav>
        <div class="contact">
          <div>
            <i class="material-icons">phone</i>
            <div class="triangle"></div>
            <div class="extend">
              <a href="tel:+48713369521">+48 71 336 95 21</a>
            </div>
          </div>
          <div>
            <i class="material-icons">email</i>
            <div class="triangle"></div>
            <div class="extend">
              <a href="mailto:bok@afkcob.pl">bok@afkcob.pl</a>
            </div>
          </div>
        </div>
        <!-- <div class="language">
          <div class="choose" :class="{ active: languagesMenuVisibility }" @click="toggleLanguageMenu()">
            <p title="Zmień język">{{ languageActive }}</p>
            <i class="material-icons" v-if="!languagesMenuVisibility">keyboard_arrow_down</i>
            <i class="material-icons" v-if="languagesMenuVisibility">keyboard_arrow_up</i>
          </div>
          <ul v-if="languagesMenuVisibility">
            <li v-for="language in languagesInactive" :key="language.name" @click.prevent="chooseLanguage(language.name)">{{ language.name }}</li>
          </ul>
        </div> -->
      </div>
      <nav class="mobile">
        <ul>
          <li @click="showMobileNav()" title="Menu"><i class="material-icons">menu</i></li>
          <li style="display: none;" @click="scrollToTop()" title="Przewiń na samą górę"><i class="material-icons">keyboard_arrow_up</i></li>
        </ul>
      </nav>
    </header>
</template>

<script>
export default {
  name: 'HeaderMain',
  data(){
    return{
      fixedNav: 0,
      languagesMenuVisibility: 0,
      languagesAll: [{ name: 'pl', value: 0 }, { name: 'en', value: 0 }, { name: 'de', value: 0 }, { name: 'ua', value: 0 }],
      languagesInactive: [],
      languageActive: 'pl',
    }
  },
  computed:{
    route(){
      return this.$store.state.route;
    },
    panel() {
      return this.$store.state.panel;
    },
  },
  created(){
    if(typeof localStorage.language === 'undefined'){
      this.chooseLanguage('pl');
    }else{
      this.languageActive = localStorage.language;
      this.changeLanguage(this.languageActive)
    }
  },
  mounted(){
    window.addEventListener('scroll', this.fixNav);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.fixNav);
  },
  methods:{
    fixNav(){
      if(window.scrollY >= 60){
        this.fixedNav = 1;
      }else{
        this.fixedNav = 0;
      }
    },
    showMobileNav(){
      this.$store.commit('toggleMobileNav');
      document.body.style = "overflow-y: hidden";
    },
    scrollToTop(){
      window.scrollTo(0, 0);
    },
    toggleLanguageMenu(){
      if(this.languagesMenuVisibility == 1){
        this.languagesMenuVisibility = 0;
      }else{
        this.languagesMenuVisibility = 1; 
      }
    },
    changeLanguage(name){
      for(let i = 0; i < this.languagesAll.length; i++){
        if(name == this.languagesAll[i].name){
          this.languagesAll[i].value = 1;
        }else{
          this.languagesAll[i].value = 0;
        }
      }
      this.languagesInactive = []
      for(let i = 0; i < this.languagesAll.length; i++){
        if(this.languagesAll[i].value == 0){
          this.languagesInactive.push(this.languagesAll[i])
        }
      }
    },
    chooseLanguage(name){
      this.changeLanguage(name)
      if(typeof localStorage.language === 'undefined'){
        localStorage.setItem("language", name);
      }else{
        localStorage.language = name;
      }
      this.languageActive = name;
      this.languagesMenuVisibility = 0;
    }
  }
}
</script>

<style scoped lang="scss">
  header { display: flex; justify-content: space-between; align-items: center; width: 100vw; height: 60px; position: fixed; top: 0; left: 0;
   background: $grayDark; box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5); z-index: 3; }
  header a { margin-left: 50px; text-decoration: none; }
  header a h1 { padding: 0 0 0 67px; font-size: 24px; color: #fff; font-family: 'Fira Sans', sans-serif; font-weight: 300; text-decoration: none; 
    background: url('../assets/logo_27_white.png') no-repeat; cursor: pointer; font-family: 'Aspergit Regular', sans-serif; letter-spacing: 1px; }
  header a.tel { display: none; margin: 0; color: #fff; }
  header div.flexi { display: flex; }
  header nav { overflow: hidden; }
  header nav ul { display: flex; margin: 0; padding: 0; list-style: none; }
  header nav.main { display: block; }
  header nav.main ul li { margin: 0 5px; position: relative; }
  header nav.main ul li a { display: block; margin: 0; padding: 9px 30px; text-decoration: none; font-weight: 300; font-size: 13px; color: rgba(255, 255, 255, 1); 
    text-transform: uppercase; letter-spacing: 1px; border-radius: 25px; }
  header nav ul li a.active { background: rgba(255, 255, 255, 0.1); }
  header nav ul li a:hover { background: rgba(255, 255, 255, 0.1); }
  header nav.mobile { display: none; }
  header nav.mobile ul { justify-content: space-between; }
  header nav.mobile ul li { display: flex; justify-content: center; align-items: center; width: 60px; height: 60px; }
  header nav.mobile ul li i.material-icons { color: rgba(255, 255, 255, 1); font-size: 32px; cursor: pointer; }
  header nav.mobile ul li:hover { background: rgba(255, 255, 255, 0.1); }
  header div.contact { display: flex; margin: 0 30px 0 40px;  }
  header div.contact div { display: flex; justify-content: center; align-items: center; width: 35px; height: 35px; margin: 0 5px; position: relative; cursor: pointer; }
  header div.contact div i.material-icons { color: rgba(255, 255, 255, 0.7); font-size: 18px; }
  header div.contact div:hover i.material-icons { color: #fff; }
  header div.contact div div.triangle { display: none; width: 0; height: 0; position: absolute; top: 28px; border-left: 7px solid transparent; border-right: 7px solid transparent; 
    border-bottom: 7px solid $orangeLight; z-index: 2; }
  header div.contact div:hover div.triangle { display: block; }
  header div.contact div div.extend { display: none; justify-content: center; align-items: center; width: 145px; position: absolute; top: 35px; 
  background: $orangeLight; border-radius: 5px; cursor: default; box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2); z-index: 1; }
  header div.contact div:nth-child(2) div.extend { width: 140px; right: -25px; }
  header div.contact div:hover div.extend { display: flex; }
  header div.contact div div.extend p { margin: 0; padding:0; color: #fff; font-size: 14px; }
  header div.contact div div.extend a { margin: 0; padding:0; color: #fff; font-size: 14px; }
  header div.language { display: flex; flex-direction: column; justify-content: center; align-items: center; margin: 0 40px 0 15px; position: relative; }
  header div.language div.choose { display: flex; justify-content: center; align-items: center; width: 50px; margin-top: -2px; padding: 3px 2px; cursor: pointer; 
   border-top-left-radius: 5px; border-top-right-radius: 5px; }
  header div.language div.choose.active { background: $orangeLight; }
  header div.language div.choose p { margin: 0; padding: 0; font-size: 14px; color: #fff; text-transform: uppercase; font-weight: 300; letter-spacing: 1px; }
  header div.language div.choose i.material-icons { display: block; color: rgba(255, 255, 255, 0.5); font-size: 18px; }
  header div.language ul { margin: 0; padding: 0; position: fixed; top: 40px; list-style: none; background: $orangeLight; border-bottom-left-radius: 5px; 
    border-bottom-right-radius: 5px; }
  header div.language ul li { width: 50px; margin: 0; padding: 3px 2px; font-size: 14px; color: #fff; text-transform: uppercase; letter-spacing: 1px; font-weight: 300;
    text-align: center; cursor: pointer; border-radius: 5px; }
  header div.language ul li:hover { background: rgba(255, 255, 255, 0.7); color: $fontBlack; }
  
  @media (max-width: 1250px) {
    header nav.main ul li { margin: 0 3px; }
    header nav.main ul li a { padding: 7px 20px; }
  }

  @media (max-width: 1100px) {
    header { justify-content: flex-start; }
    header a.tel { display: inline; }
    header nav.main { display: none; }
    header div.contact { display: none; }
    header div.language { display: none; }
    header nav.mobile { display: block; margin-left: auto; }
    h1 { margin: 0 0 0 10px; text-indent: -999px; }
    header a { margin: 0 10px; }
  }

  @media (max-width: 325px) {
    h1 { margin: 0 0 0 10px; }
  }
  @media (max-width: 300px) {
    header a.tel { display: none; }
  }
</style>
